module.exports = __webpack_public_path__ + "img/default.6fc6e967.jpg";